import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useEffect } from 'react';
import { useDynamicDrawerContext } from '../../context/dynamic-drawer.context';
import { useGetBillsLazyQuery } from '../../types';
import AdminFeeBillsList from './admin-fee-bills-list';
import { BillSource } from './bill-types';

const UserAdminFeeBills = ({ userUuid }: { userUuid: string }): JSX.Element => {
  const { onClose } = useDynamicDrawerContext();
  const [getUserAdminFeeBills, { data, loading, error }] =
    useGetBillsLazyQuery();

  useEffect(() => {
    getUserAdminFeeBills({
      variables: {
        userUuids: [userUuid],
        source: BillSource.ADMIN_FEE_CLAIMS,
        page: 1,
        // ponytail: single-page cap; add real pagination if a user ever has >100 AFC bills
        size: 100,
      },
    });
  }, [userUuid, getUserAdminFeeBills]);

  useEffect(
    () => () => {
      onClose();
    },
    [onClose],
  );

  if (error && !loading) {
    return (
      <HHAlert hhVariant="outlined" severity="error">
        <HHTypography hhVariant="body">
          There was an error loading user admin fee bills
        </HHTypography>
      </HHAlert>
    );
  }

  return (
    <HHStack flex={1} spacing={8} direction="column" padding={1} paddingTop={4}>
      <HHStack spacing={1}>
        <HHStack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HHTypography hhVariant="subtitle1">Admin Fee Bills</HHTypography>
        </HHStack>
        <AdminFeeBillsList data={data?.getBills} loading={loading} />
      </HHStack>
    </HHStack>
  );
};

export default UserAdminFeeBills;
